import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/Shallot.png";
import sliced from "../../assets/images/ingredients/Shallot_Chopped.png";

const Shallot = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Shallot"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Shallot;